import axios from "axios";

const host = process.env.REACT_APP_BACKEND_HOST;

const instance = axios.create({
  baseURL: host,
  headers: {
    "Content-Type": "application/json"
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth-token");
    if (token !== null) {
      config.headers.common["Authorization"] = `Token ${token}`;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export default instance;
